import { useQuery } from "@tanstack/react-query"
import { AcquisitionMode, AcquisitionModeInFlightplan, AoiSpecs } from "../models/AcquisitionMode"
import { API, NexusResponse } from "./API"
import { QueryKeys } from "./QueryConfig"

export const useFindAcquisitionModes = () => {
    return useQuery({
        queryKey: [QueryKeys.FIND_ACQUISITION_MODES],
        queryFn: async () => {
            const result: NexusResponse<AcquisitionMode[]> = await API.get(
                "/acquisition-modes",
                "Couldn't fetch acquisition modes.",
            )
            return result.data
        },
    })
}

export const useFindAcquisitionModesAoiSpecs = () => {
    return useQuery({
        queryKey: [QueryKeys.FIND_ACQUISITION_MODES_AOI_SPECS],
        queryFn: async () => {
            const result: NexusResponse<AoiSpecs> = await API.get(
                "/acquisition-modes/aoi-specs",
                "Couldn't fetch AOI specs.",
            )
            return result.data
        },
    })
}

export const useFindAcquisitionModesForFlightPlan = (flightPlanId?: number) => {
    return useQuery({
        queryKey: [QueryKeys.FIND_ACQUISITION_MODES_FOR_FLIGHT_PLAN, flightPlanId],
        queryFn: async () => {
            const result: NexusResponse<AcquisitionModeInFlightplan[]> = await API.get(
                `/flight-plan-acquisition-modes/${flightPlanId}`,
                "Couldn't fetch acquisition modes.",
            )
            return result.data
        },
        enabled: flightPlanId != null,
        gcTime: 0,
    })
}
